import "./input.scss";

import React, { Fragment } from "react";
import { FormInput } from "shards-react";

const TextInput = ({
  input,
  width,
  type,
  placeholder,
  meta: { touched, error }
}) => {
  return (
    <Fragment>
      <div>
        <FormInput
          {...input}
          placeholder={placeholder}
          invalid={touched && error}
          type={type}
          className="form-control"
        ></FormInput>
        {touched && error && <label className="error-label">{error}</label>}
      </div>
    </Fragment>
  );
};

export default TextInput;
